/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Searchplaceholder1Inputs */

const id_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari di database…`)
};

const ms_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari pangkalan data…`)
};

const da_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søg i databasen…`)
};

const de_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenbank durchsuchen…`)
};

const en_us2_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search the database…`)
};

const es_es2_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar en la base de datos…`)
};

const es_mx2_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar en la base de datos…`)
};

const fil_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap sa database…`)
};

const fr_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher dans la base de données…`)
};

const it_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca nel database…`)
};

const hu_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keresés az adatbázisban…`)
};

const nl_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doorzoek de database…`)
};

const no_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søk i databasen…`)
};

const pl_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szukaj w bazie danych…`)
};

const pt_br2_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquise no banco de dados…`)
};

const pt_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar na base de dados…`)
};

const ro_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caută în baza de date…`)
};

const fi_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hae tietokannasta…`)
};

const sv_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sök i databasen…`)
};

const vi_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm kiếm trong cơ sở dữ liệu…`)
};

const tr_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veritabanında ara…`)
};

const cs_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat v databázi…`)
};

const bg_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Търсене в базата данни…`)
};

const ru_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск в базе данных…`)
};

const uk_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пошук у базі даних…`)
};

const ar_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابحث في قاعدة البيانات...`)
};

const hi_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेटाबेस खोजें…`)
};

const th_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาในฐานข้อมูล…`)
};

const ja_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データベースを検索…`)
};

const zh_cn2_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索数据库...`)
};

const zh_hant1_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜尋資料庫...`)
};

const ko_home_hero_searchplaceholder1 = /** @type {(inputs: Home_Hero_Searchplaceholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`데이터베이스 검색…`)
};

/**
* | output |
* | --- |
* | "Search the database…" |
*
* @param {Home_Hero_Searchplaceholder1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_hero_searchplaceholder1 = /** @type {((inputs?: Home_Hero_Searchplaceholder1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Searchplaceholder1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_hero_searchplaceholder1(inputs)
	if (locale === "ms") return ms_home_hero_searchplaceholder1(inputs)
	if (locale === "da") return da_home_hero_searchplaceholder1(inputs)
	if (locale === "de") return de_home_hero_searchplaceholder1(inputs)
	if (locale === "en-US") return en_us2_home_hero_searchplaceholder1(inputs)
	if (locale === "es-ES") return es_es2_home_hero_searchplaceholder1(inputs)
	if (locale === "es-MX") return es_mx2_home_hero_searchplaceholder1(inputs)
	if (locale === "fil") return fil_home_hero_searchplaceholder1(inputs)
	if (locale === "fr") return fr_home_hero_searchplaceholder1(inputs)
	if (locale === "it") return it_home_hero_searchplaceholder1(inputs)
	if (locale === "hu") return hu_home_hero_searchplaceholder1(inputs)
	if (locale === "nl") return nl_home_hero_searchplaceholder1(inputs)
	if (locale === "no") return no_home_hero_searchplaceholder1(inputs)
	if (locale === "pl") return pl_home_hero_searchplaceholder1(inputs)
	if (locale === "pt-BR") return pt_br2_home_hero_searchplaceholder1(inputs)
	if (locale === "pt") return pt_home_hero_searchplaceholder1(inputs)
	if (locale === "ro") return ro_home_hero_searchplaceholder1(inputs)
	if (locale === "fi") return fi_home_hero_searchplaceholder1(inputs)
	if (locale === "sv") return sv_home_hero_searchplaceholder1(inputs)
	if (locale === "vi") return vi_home_hero_searchplaceholder1(inputs)
	if (locale === "tr") return tr_home_hero_searchplaceholder1(inputs)
	if (locale === "cs") return cs_home_hero_searchplaceholder1(inputs)
	if (locale === "bg") return bg_home_hero_searchplaceholder1(inputs)
	if (locale === "ru") return ru_home_hero_searchplaceholder1(inputs)
	if (locale === "uk") return uk_home_hero_searchplaceholder1(inputs)
	if (locale === "ar") return ar_home_hero_searchplaceholder1(inputs)
	if (locale === "hi") return hi_home_hero_searchplaceholder1(inputs)
	if (locale === "th") return th_home_hero_searchplaceholder1(inputs)
	if (locale === "ja") return ja_home_hero_searchplaceholder1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_hero_searchplaceholder1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_hero_searchplaceholder1(inputs)
	return ko_home_hero_searchplaceholder1(inputs)
});
export { home_hero_searchplaceholder1 as "home.hero.searchPlaceholder" }